import { trackEvent } from '@/utils/gtags';

import type { LanguageType } from '@/types/language';

export type FaqAnalyticsAction =
  | 'faq_view'
  | 'faq_topic_select'
  | 'faq_search'
  | 'faq_search_clear'
  | 'faq_answer_open'
  | 'faq_answer_close'
  | 'faq_ai_select'
  | 'faq_prompt_copy'
  | 'faq_inquiry_click'
  | 'faq_solution_click';

type FaqEventParameters = {
  faq_id?: string;
  topic_id?: string;
  ai_service?: string;
  query_length?: number;
  result_count?: number;
  has_results?: boolean;
  success?: boolean;
  context?: 'search_empty' | 'page_footer';
};

// Pass only machine identifiers and aggregate search metadata. Never send
// user-entered questions, prompt text, or external AI URLs to analytics.
export function trackFaqEvent(
  action: FaqAnalyticsAction,
  locale: LanguageType,
  parameters: FaqEventParameters = {},
) {
  return trackEvent(action, {
    content_type: 'faq',
    language: locale,
    ...parameters,
  });
}
